module.exports = __webpack_public_path__ + "media/src/components/Navigation/NotificationHeader/img/premiumBrandPurple-19361cd650d4a5d3003356606c57cdb4.png";